import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import products from './productsReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
const store = createStore(products, composeEnhancers(applyMiddleware(thunk)));

export default store;
